/* FP: cart helper + pre built bundle add to cart (Pipeline 7) */
/* =========================================================
   FPBB Cart helper - uses Pipeline's OWN add to cart flow
   (same as the theme product-add-button + cart popdown):
     1. POST /cart/add.js  (XHR, form-urlencoded, X-Requested-With)
     2. GET  /cart.js  -> document "theme:cart:change" {cart}
     3. drawer [data-drawer="drawer-cart"]:
        "theme:drawer:reload" then "theme:drawer:open"
   No page reload, no redirect, no extra events.
   ========================================================= */
(function () {
  if (window.FPBBCart && window.FPBBCart.native) return;

  function cartRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) ||
      (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart');
  }

  /* items -> "items[0][id]=1&items[0][quantity]=2&items[0][properties][x]=y" */
  function encodeItems(items) {
    var parts = [];
    items.forEach(function (it, i) {
      var p = 'items[' + i + ']';
      parts.push(encodeURIComponent(p + '[id]') + '=' + encodeURIComponent(it.id));
      parts.push(encodeURIComponent(p + '[quantity]') + '=' + encodeURIComponent(it.quantity));
      if (it.selling_plan) parts.push(encodeURIComponent(p + '[selling_plan]') + '=' + encodeURIComponent(it.selling_plan));
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          parts.push(encodeURIComponent(p + '[properties][' + k + ']') + '=' + encodeURIComponent(it.properties[k]));
        });
      }
    });
    return parts.join('&');
  }

  function xhr(method, url, body) {
    return new Promise(function (resolve, reject) {
      var r = new XMLHttpRequest();
      r.open(method, url, true);
      r.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      r.setRequestHeader('Accept', 'application/json');
      if (body) r.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      r.onload = function () {
        var data = null;
        try { data = JSON.parse(r.responseText); } catch (e) {}
        if (r.status >= 200 && r.status < 300) resolve(data);
        else reject(new Error((data && (data.description || data.message)) || 'Could not add to cart'));
      };
      r.onerror = function () { reject(new Error('Network error: please try again')); };
      r.send(body || null);
    });
  }

  function getDrawer() { return document.querySelector('[data-drawer="drawer-cart"]'); }
  function isOpen() { var d = getDrawer(); return !!(d && d.classList.contains('drawer--visible')); }

  /* Wait until the drawer's line items have been re-rendered (max 4s).
     The theme refills the drawer with a fetch of ?section_id=api-cart-items;
     other apps can make that slow, so opening right away showed an empty/old cart. */
  function waitForItems(timeout) {
    return new Promise(function (resolve) {
      var box = document.querySelector('[data-drawer="drawer-cart"] [data-line-items]') || document.querySelector('[data-line-items]');
      if (!box) { resolve(); return; }
      var done = false, t, obs;
      var finish = function () { if (done) return; done = true; if (obs) obs.disconnect(); clearTimeout(t); resolve(); };
      obs = new MutationObserver(finish);
      obs.observe(box, { childList: true });
      t = setTimeout(finish, timeout || 4000);
    });
  }

  /* Reload the cart drawer content FIRST, then open it */
  function open() {
    var cartPage = document.querySelector('[data-ajax-disable="false"]');
    if (cartPage) { cartPage.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true })); return; }
    if (window.FPCartBusy) { window.FPCartBusy.finish(); return; }
    var d = getDrawer();
    if (!d) return;
    d.dispatchEvent(new CustomEvent('theme:drawer:reload', { bubbles: false }));
    var filled = waitForItems(4000);
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    if (isOpen()) return;
    filled.then(function () {
      if (!isOpen()) d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    });
  }

  function add(items) {
    items = (items || []).filter(function (i) { return i && i.id && Number(i.quantity) > 0; });
    if (!items.length) return Promise.reject(new Error('No items to add'));
    if (window.FPCartBusy) window.FPCartBusy.start();
    return xhr('POST', cartRoute() + '/add.js', encodeItems(items))
      .then(function () { return xhr('GET', cartRoute() + '.js'); })
      .then(function (cart) {
        /* Same event the theme fires after add (header count, drawer data, free shipping bar) */
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        open();
        return cart;
      }, function (err) {
        if (window.FPCartBusy) window.FPCartBusy.fail();
        throw err;
      });
  }

  window.FPBBCart = { add: add, open: open, isOpen: isOpen, native: true };
})();

/* =========================================================
     FP bundle add to cart (product page)
     Jab koi Pre built bundle select ho: main Add to cart aur
     sticky Add to cart SIRF bundle products add karte hain
     (original product nahi) aur cart drawer open hota hai.
     Koi bundle select nahi = theme ka normal Add to cart.
     ========================================================= */
  window.FPDBBundleATC = { init: function (SECTION_ID) {
    var root = document.getElementById('fpdb-' + SECTION_ID);
    if (!root || root.dataset.fpdbBundleAtc === '1') return;
    root.dataset.fpdbBundleAtc = '1';

    var cfg = {};
    try { cfg = JSON.parse((root.querySelector('[data-fpdb-config]') || {}).textContent || '{}'); } catch (e) {}
    var variantIds = [];
    try {
      var prod = JSON.parse((root.querySelector('[data-fpdb-product]') || {}).textContent || '{}');
      variantIds = (prod.variants || []).map(function (v) { return String(v.id); });
    } catch (e) {}

    var BTN_SEL = 'button[name="add"], [data-add-to-cart], [data-add-to-cart-button], .btn--add-to-cart, .product__submit__add, button[type="submit"]';

    function liveRoot() {
      /* siblings swap can replace the section: always use the current one */
      return document.getElementById('fpdb-' + SECTION_ID) || root;
    }

    function selectedCard() {
      var r = liveRoot();
      return r.querySelector('[data-fpdb-pbb] [data-fpdb-bundle].fpdb-pbb--on:not(.fpdb-pbb--off)');
    }

    function bundleItems() {
      var card = selectedCard();
      if (!card) return [];
      var items;
      try { items = JSON.parse(card.getAttribute('data-fpdb-bundle-items') || '[]'); } catch (e) { items = []; }
      return items
        .filter(function (it) { return it && it.id && Number(it.quantity) > 0; })
        .map(function (it) { return { id: Number(it.id), quantity: Number(it.quantity) }; });
    }

    /* Is this form the main product form of this section? */
    function isMainForm(form) {
      if (!form || !form.matches) return false;
      if (form.matches('.fprp-card__form, [data-fpbb-ajax], [id^="instant-form-"]')) return false;
      var fid = form.getAttribute('id') || '';
      var r = liveRoot();
      if (cfg.formId && (fid === cfg.formId || form.closest('#' + CSS.escape(cfg.formId)))) return true;
      if (form.closest('.fpdb-block--add-buttons') && r.contains(form)) return true;
      if (!r.contains(form)) return false;
      if (form.closest('[data-fpdb-modal], .fpdb-block--upsell, .fpdb-block--complimentary, .product__upsell, .upsell')) return false;
      var idInput = form.querySelector('[name="id"]');
      return !!(idInput && variantIds.indexOf(String(idInput.value)) > -1);
    }

    /* Returns the Add to cart button that was clicked (main or sticky) or null */
    function mainAtcButton(target) {
      if (!target || !target.closest) return null;
      var r = liveRoot();
      var sticky = target.closest('[data-fpdb-satc-btn]');
      if (sticky && (r.contains(sticky) || sticky.closest('[data-fpdb-satc]'))) return sticky;
      var btn = target.closest(BTN_SEL);
      if (!btn) return null;
      if (btn.closest('[data-fpdb-pbb], [data-fpdb-modal]')) return null;
      var form = btn.form || btn.closest('form');
      if (form && isMainForm(form)) return btn;
      /* Button without form but inside the add buttons block */
      if (!form && btn.closest('.fpdb-block--add-buttons') && r.contains(btn)) return btn;
      return null;
    }

    var busy = false;
    function setLoading(btn, on) {
      var main = liveRoot().querySelectorAll('.fpdb-block--add-buttons ' + BTN_SEL + ', [data-fpdb-satc-btn]');
      var list = Array.prototype.slice.call(main);
      if (btn && list.indexOf(btn) === -1) list.push(btn);
      list.forEach(function (b) {
        b.classList.toggle('loading', on);
        b.classList.toggle('is-loading', on);
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
    }

    function addBundle(btn) {
      var items = bundleItems();
      if (!items.length || busy) return;
      if (!window.FPBBCart) { console.error('FPBBCart helper missing'); return; }
      busy = true;
      setLoading(btn, true);
      window.FPBBCart.add(items)
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('fpdb:bundle:added', { bubbles: true, detail: { items: items, cart: cart } }));
        })
        .catch(function (err) {
          console.error('FP bundle add to cart error:', err);
          alert(err.message || 'Something went wrong. Please try again.');
        })
        .then(function () {
          busy = false;
          setLoading(btn, false);
        });
    }

    function stop(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    /* window + capture = runs BEFORE the theme's own Add to cart code */
    /* Sirf tab rokna hai jab bundle select ho AUR uske products valid hon.
       Warna theme ka normal Add to cart chalega (main product add hoga). */
    /* Default (pehle se selected) bundle ko ignore karo: main Add to cart
       tabhi bundle add karega jab CUSTOMER khud kisi bundle pe click kare. */
    var picked = false;
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-fpdb-pbb] [data-fpdb-bundle]');
      if (card && liveRoot().contains(card)) picked = true;
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('[data-fpdb-pbb] [data-fpdb-bundle]');
      if (card && liveRoot().contains(card)) picked = true;
    }, true);

    function hasBundle() { return !!selectedCard() && bundleItems().length > 0; }

    window.addEventListener('click', function (e) {
      if (!hasBundle()) return;
      var btn = mainAtcButton(e.target);
      if (!btn || btn.disabled) return;
      console.log('[FPDB] Bundle selected -> Add to cart adds bundle products only', bundleItems());
      stop(e);
      addBundle(btn);
    }, true);

    /* Enter key / programmatic submit of the main form */
    window.addEventListener('submit', function (e) {
      if (!hasBundle() || !isMainForm(e.target)) return;
      stop(e);
      addBundle(e.submitter || e.target.querySelector('[type="submit"]'));
    }, true);
  } };

/* =========================================================
   FP: Custom product cards (Related products slider etc.)
   .fprp-card__form / .fprp-card__atc  -> add to cart + open drawer
   Aur koi custom card ho to uske form pe  data-fpbb-ajax  laga do.
   ========================================================= */
(function () {
  if (window.__fpbbCardForms) return;
  window.__fpbbCardForms = true;

  var FORM_SEL = 'form.fprp-card__form, form[data-fpbb-ajax]';
  var BTN_SEL = '.fprp-card__atc, [data-fpbb-ajax] [type="submit"], [data-fpbb-ajax] [name="add"]';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function itemFromForm(form) {
    var fd = new FormData(form);
    var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 };
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value !== '') props[m[1]] = value;
    });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  function setState(btn, state) {
    if (!btn) return;
    btn.classList.remove('is-loading', 'loading', 'is-added');
    if (state === 'loading') {
      btn.classList.add('is-loading', 'loading');
      btn.setAttribute('aria-busy', 'true');
      btn.style.opacity = '0.6';
    } else {
      btn.removeAttribute('aria-busy');
      btn.style.opacity = '';
    }
    if (state === 'added') {
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
    }
  }

  function addFromForm(form, btn) {
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    var item = itemFromForm(form);
    if (!item.id) { console.error('FP card add: variant id missing in form', form); return; }
    setState(btn, 'loading');
    window.FPBBCart.add([item])
      .then(function () { setState(btn, 'added'); })
      .catch(function (err) {
        setState(btn, null);
        console.error('FP card add error:', err);
        alert(err.message || 'Something went wrong. Please try again.');
      });
  }

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(BTN_SEL);
    if (!btn || btn.disabled) return;
    var form = btn.form || btn.closest('form');
    if (!form || !form.matches(FORM_SEL)) return;
    stop(e);
    addFromForm(form, btn);
  }, true);

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches(FORM_SEL)) return;
    stop(e);
    addFromForm(form, e.submitter || form.querySelector(BTN_SEL));
  }, true);
})();
